import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import EmployeeRecord from '../components/HRAdmin/EmployeeRecord';
import NavBar from '../components/Menu/NavBar'
import { pageStyle } from '../components/UIComponent/CommonStyle'
import { setLocalStorageSettings } from '../components/Function/globalFunction';

const useStyles = makeStyles(() => ({
    ...pageStyle()
}));

export default function EmployeeRecordPage() {
    const classes = useStyles();
    setLocalStorageSettings({
        'selectedIndex': 10,
        'isMyRequestOpen': 'false',
        'isApplicationOpen': 'false',
        'isLeaveApprovalOpen': 'false',
        'isHRAdminOpen': 'true'
    });

    return (
        <div className={classes.root}>
            <CssBaseline />
            <NavBar />
            <EmployeeRecord />
        </div>
    )
}